import { create } from 'zustand';
import { LinkedGroupMemberData } from '../dto/EntityRepository';
import type { ResourceStatus } from '../util/scopedResource';

interface LinkedGroupMemberState {
  connections: LinkedGroupMemberData[];
  listOwnerAui: string | null;
  status: ResourceStatus;
  setConnections: (connections: LinkedGroupMemberData[], ownerAui: string) => void;
  setLoading: (ownerAui: string) => void;
  setError: () => void;
  removeConnection: (groupMemberId: string, ownerAui: string) => void;
}

export const useLinkedGroupMemberStore = create<LinkedGroupMemberState>((set) => ({
  connections: [],
  listOwnerAui: null,
  status: 'idle',
  setConnections: (connections, ownerAui) => set({
    connections,
    listOwnerAui: ownerAui,
    status: 'success',
  }),
  setLoading: (ownerAui) => set((state) => (
    state.listOwnerAui === ownerAui && state.status === 'success'
      ? state
      : { status: 'loading' }
  )),
  setError: () => set({ status: 'error' }),
  removeConnection: (groupMemberId, ownerAui) => set((state) => {
    if (state.listOwnerAui !== ownerAui) return state;
    return {
      connections: state.connections.filter(
        (connection) => connection.groupMember.id !== groupMemberId,
      ),
    };
  }),
}));
